module.exports = __webpack_public_path__ + "img/05.85697d4a.jpg";